exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slot > td > .edit[data-v-46aa2e29] {\n  display: none;\n}\n.slot > td:hover > .edit[data-v-46aa2e29] {\n  display: block;\n}\n", ""]);

// exports
